/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Account_UnsuspendInputs */



/**
* | output |
* | --- |
* | "Restored a suspended account" |
*
* @param {Activity_Account_UnsuspendInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_account_unsuspend = /** @type {((inputs?: Activity_Account_UnsuspendInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Account_UnsuspendInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приостановленный аккаунт восстановлен")
	return /** @type {LocalizedString} */ ("Restored a suspended account")
});